import React from 'react';

import { Box, useTheme } from '@mui/material';

import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';

import BaseActionButton from '../BaseActionButton';
import { IBaseActionButtonProps } from '../interfaces';
import { useStyles } from './styles';

export interface ICommentActionButtonProps extends IBaseActionButtonProps {
  hasComments?: boolean;
}

const CommentActionButton = (props: ICommentActionButtonProps) => {
  const { hasComments = false, ...rest } = props;
  const theme = useTheme();
  const { classes } = useStyles(theme);

  return (
    <BaseActionButton {...rest}>
      <Box component="span" className={classes.iconWrapper}>
        <ModeCommentOutlinedIcon />
        {hasComments && (
          <Box
            component="span"
            className={classes.commentIndicator}
            aria-hidden
          />
        )}
      </Box>
    </BaseActionButton>
  );
};

export default CommentActionButton;
